import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import {
  Badge,
  BadgeStatusEntrega,
  Btn,
  CustomDataTableHeader,
  CustomPanel,
  Loading,
  NumeroDecimal,
  PageHeader,
  ThreeDots,
} from '../../../../components'

import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import _ from 'lodash'
import { ModalOcorrenciasEntrega } from '../Ocorrencias/OcorrenciaEntrega/OcorrenciasEntrega'
import ModalEmitirCte from '../RetornoVeiculoApuracao/Cte/ModalEmitirCte'
import ModalEmitirCteEmpresaCliente from '../RetornoVeiculoApuracao/Cte/ModalEmitirCteEmpresaCliente'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import { getValorFrete } from '../../../../services/api/https/registration/regras-frete.http'

function VeiculosRetornadosApuracao({ dispatch, selectedTp, history }) {
  // Vars
  const {
    location: {
      state: { fleet_id, vehicle_badge, driver_id, expected_date },
    },
  } = history

  // Hooks
  const [entregas, setEntregas] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [modalOcorrenciasEntrega, setModalOcorrenciasEntrega] = useState({
    show: false,
    data: null,
  })
  const [modalCte, setModalCte] = useState({ show: false, data: null, consolidado: null })
  const [modalCteEmpresaCliente, setModalCteEmpresaCliente] = useState({ show: false })

  useEffect(() => {
    getEntregas()
  }, [fleet_id])

  // Events
  const onHeaderBtnClicked = action => {
    try {
      if (action === 'sobras') {
        history.push('/main/entregas/ocorrencias/sobras', {
          fleet_id,
          vehicle_badge,
        })
        return
      }
      throw new Error('Ação Incorreta')
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Helper
  const getEntregas = async () => {
    try {
      const fetchedEntregas = await RetornoHttp.getEntregas(fleet_id, selectedTp)
      const deliveriesDesc = _.orderBy(fetchedEntregas, 'load_order', 'desc')
      deliveriesDesc.forEach((e, index) => (e.load_order = e.load_order ? index + 1 : ''))

      setIsLoading(false)
      setEntregas(deliveriesDesc)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onMenuItemClicked = async (menuItem, entrega) => {
    const { delivery_id, identifier, nomeFantasia, company_id, delivery_step_id, company_name } =
      entrega

    try {
      switch (menuItem) {
        case '1. Chat':
          history.push('/main/entregas/chat', {
            delivery_id,
            company_name,
            vehicle_badge,
            tp_id: selectedTp,
            driver_id,
            weight: entrega.weightTotal,
            expected_date,
            disabled: true,
          })
          break
        case '2. Ocorrência Produto':
          history.push('/main/entregas/ocorrencias/faltas', {
            delivery_id,
            identifier,
            nomeFantasia,
            company_id,
            delivery_step_id,
          })
          break
        case '3. Ocorrências Entrega':
          setModalOcorrenciasEntrega({ show: true, data: entrega })
          break
        case '4. Emitir CTe':
          if (entrega.cte_status === 'autorizado') {
            throw new Error('Emissão de CTe já solicitada. Status: autorizado')
          }
          if (entrega.cte_status === 'processando_autorizacao') {
            throw new Error('Emissão de CTe já solicitada. Status: processando_autorizacao')
          }
          await getValorFrete(delivery_id)
          setModalCte({ show: true, data: entrega, consolidado: null })
          break
        default:
          throw new Error('Item do menu Incorreto')
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Render
  return (
    <>
      <PageHeader>
        Entregas Veículo Retornado &nbsp;
        <strong>{vehicle_badge}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div
              className="p-col-12"
              style={{
                overflow: 'hidden',
                padding: 0,
                margin: '8px',
                width: 'auto',
              }}
            >
              <Btn
                backgroundColor={colors.azul}
                onClick={() => onHeaderBtnClicked('sobras')}
                style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
              >
                Sobras
              </Btn>
              {menuItemsAllowed([{ id: 40, content: "3.18 - Gestão de CTe's" }]).length > 0 && (
                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                  <Btn
                    backgroundColor={colors.verde_escuro}
                    onClick={() => setModalCteEmpresaCliente({ show: true })}
                    style={{ minWidth: 'auto', padding: '14px', borderRadius: '10px' }}
                  >
                    Emitir CTe Empresa-Cliente
                  </Btn>
                </div>
              )}
            </div>
            <div className="p-col-12">
              {isLoading ? (
                <div className="text-center" style={{ marginTop: 20 }}>
                  <Loading />
                </div>
              ) : (
                <DataTableComponent entregas={entregas} onMenuItemClicked={onMenuItemClicked} />
              )}
            </div>
          </div>
        </CustomPanel>

        <ModalOcorrenciasEntrega
          visible={modalOcorrenciasEntrega.show}
          deliveryStepVehicleId={
            modalOcorrenciasEntrega.data
              ? modalOcorrenciasEntrega.data.delivery_step_vehicle_id
              : null
          }
          fleetId={fleet_id}
          identifier={modalOcorrenciasEntrega.data ? modalOcorrenciasEntrega.data.identifier : null}
          onClose={() => setModalOcorrenciasEntrega({ show: false, data: null })}
        />
        <ModalEmitirCte
          selectedTp={selectedTp}
          delivery={modalCte.data}
          consolidado={modalCte.consolidado}
          visible={modalCte.show}
          vehicleBadge={vehicle_badge}
          onModalClose={() => {
            setModalCte({ show: false, data: null, consolidado: null })
          }}
          onModalSave={() => {
            dispatch(showMessageBox('CTe enviada para emissão, aguardando resposta SEFAZ', null))

            setModalCte({ show: false, data: null, consolidado: null })
            getEntregas()
          }}
          onError={onError}
        />
        <ModalEmitirCteEmpresaCliente
          visible={modalCteEmpresaCliente.show}
          entregas={entregas}
          onModalClose={() => setModalCteEmpresaCliente({ show: false })}
          onCadastrar={consolidado => {
            setModalCteEmpresaCliente({ show: false })
            setModalCte({ show: true, data: null, consolidado })
          }}
          onError={onError}
        />
      </div>
    </>
  )
}

function DataTableComponent({ entregas, onMenuItemClicked }) {
  // Hooks
  const [globalFilter, setGlobalFilter] = useState('')

  // Helpers
  function verifyMenuItemAllowed(menuItem) {
    return menuItemsAllowed([menuItem]).length > 0
  }

  function menuItems() {
    const MENU_ITEMS = ['1. Chat', '2. Ocorrência Produto', '3. Ocorrências Entrega']

    if (verifyMenuItemAllowed({ id: 40, content: "3.18 - Gestão de CTe's" })) {
      MENU_ITEMS.push('4. Emitir CTe')
    }

    return MENU_ITEMS
  }

  // Render
  return (
    <DataTable
      value={entregas}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
      paginator={true}
      rows={10}
    >
      <Column header="Ordem" field="load_order" style={tableCellCentered(100)} />
      <Column field="identifier" header="Identif." />
      <Column field="nomeFantasia" header="Fantasia" />
      <Column field="city" header="Cidade" style={tableCellCentered(150)} />
      <Column field="district" header="Bairro" style={tableCellCentered()} />
      <Column field="company_name" header="Empresa" />
      <Column
        field="weightTotal"
        header="Peso"
        body={item => <NumeroDecimal>{item.weightTotal}</NumeroDecimal>}
        style={tableCellCentered()}
      />
      <Column field="qte_sku" header="Qte. Sku" style={tableCellCentered()} />
      <Column
        field="status"
        header="Status"
        style={tableCellCentered(130)}
        body={entrega => <BadgeStatusEntrega status={entrega.status} />}
      />
      <Column
        style={tableCellCentered(130)}
        header="Possui Falta"
        body={entrega => {
          return entrega.qte_faltas ? (
            <Badge color={colors.vinho}>sim</Badge>
          ) : (
            <Badge color={colors.verde}>não</Badge>
          )
        }}
      />
      <Column
        style={tableCellCentered(130)}
        header="CTe"
        body={entrega => {
          const getColorAndText = () => {
            if (entrega.cte_status === 'autorizado') return { color: colors.verde, text: 'Emitido' }
            if (entrega.cte_status === 'processando_autorizacao')
              return { color: colors.laranja, text: 'Processando Emissão' }
            return { color: colors.vermelho, text: 'Não Emitido' }
          }
          const { color, text } = getColorAndText()
          return <Badge color={color}>{text}</Badge>
        }}
      />
      <Column
        header="Menu"
        style={tableCellCentered(70)}
        body={entrega => (
          <ThreeDots items={menuItems()} onClick={item => onMenuItemClicked(item, entrega)} />
        )}
        bodyStyle={tableCellCentered()}
      />
    </DataTable>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(VeiculosRetornadosApuracao))
